import '../assets/css/styles.css';
import '../assets/js/main.js';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Preloader from "../assets/js/preloader.js";
import { NavLink } from "react-router-dom";

import Button from 'react-bootstrap/Button';



const About = () => {
    return (
        <div>
            <section className="about">
                <section className="home">
                    <section className="aboutus" style={{ fontSize: "16px" }}>
                        <span style={{ fontFamily: "Cocon" }}>Dropsoon</span> to serwis internetowy, który umożliwia śledzenie nadchodzących premier limitowanych produktów z branży obuwniczej! Witryna zadebiutowała 14 sierpnia 2022 jako strona internetowa www.drops0n.com zmieniając swoją nazwę 14 lutego 2023 na dropsoon
                        <br />
                    </section>
                    <span className="copyright">
                        <p>Copyright <i className="fa fa-copyright"></i> 2023 <span style={{ fontFamily: "Cocon" }}>drop<span style={{ color: "#5A69EA" }}>soon</span></span>.<span style={{ display: "block", marginTop: "10px" }}>Made by Patis0n</span></p>
                    </span>
                </section>
            </section>
        </div>
    );
}

export default About;
